import { useTranslation } from 'react-i18next';

import { getMapConfiguration, type MapLinkServices } from '@ngsos/portal-core/agency';

import { useAgencyConfiguration } from '@/app/shell/agencyConfiguration';
import type { GeoPoint } from '@/signalr';
import { createMapLinkModel } from '../../maps/externalMapLinks';

export type MapLinkPanelItemProps = {
  service: MapLinkServices;
  coordinates: GeoPoint;
};

export function MapLinkPanelItem({ service, coordinates }: MapLinkPanelItemProps) {
  const { t } = useTranslation();
  const model = createMapLinkModel(service, coordinates, {
    mapyCzAltText: t('Incident_InfoPanel_IconMapyCzAltText'),
    googleMapsAltText: t('Incident_InfoPanel_IconGoogleMapsAltText'),
  });

  return (
    <a href={model.link} target="_blank">
      <img src={model.iconPath} alt={model.altText} style={{ width: '28px', height: '28px' }} />
    </a>
  );
}

export type MapLinksPanelItemProps = {
  coordinates: GeoPoint;
};

export function MapLinksPanelItem({ coordinates }: MapLinksPanelItemProps) {
  const agencyConfiguration = useAgencyConfiguration();
  const mapConfiguration = getMapConfiguration(agencyConfiguration);

  return (
    <div className="d-flex gap-2">
      {mapConfiguration.mapLinks.map((mapLink) => (
        <MapLinkPanelItem key={mapLink} coordinates={coordinates} service={mapLink} />
      ))}
    </div>
  );
}
